import { __assign } from "tslib";
import { connect } from 'react-redux';
import LoadingScreen from '../components/LoadingScreen';
import { getPendingAndLoadedScreenCounts } from '../selectors/screen';
import { areHotspotsLoaded } from '../selectors/hotspot';
import { isPro, isEmbedded, getCompanyColourAndLogo, } from '../selectors/project';
function mapStateToProps(state) {
    return __assign(__assign({ isPro: isPro(state), areHotspotsLoaded: areHotspotsLoaded(state), isEmbedded: isEmbedded(state) }, getPendingAndLoadedScreenCounts(state)), getCompanyColourAndLogo(state));
}
export default connect(mapStateToProps)(LoadingScreen);
